import styled, { DefaultTheme } from 'styled-components';
import { getSpacingToken, getToken, Icon, Size } from '@optimus-web/core';
import { getBackgroundColor, getIconColor } from './getHighlightIconStyles';
import { HighlightIconVariant } from './types';

export const getHighlightIconSize = ({
    size,
    theme,
}: {
    size: Exclude<Size, 'large' | 'extraLarge'>;
    theme: DefaultTheme;
}) => {
    switch (size) {
        case 'small':
            return getSpacingToken('400')({ theme });
        default:
            return getSpacingToken('500')({ theme });
    }
};

export const HighlightIconElement = styled(Icon)<{
    backgroundVariant: HighlightIconVariant;
    size: Exclude<Size, 'large' | 'extraLarge'>;
}>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: ${(props) => getHighlightIconSize(props)}px;
    width: ${(props) => getHighlightIconSize(props)}px;
    border-radius: ${getToken('borderRadius100')}px;
    background-color: ${(props) => getBackgroundColor(props.backgroundVariant)};
    path {
        fill: ${(props) => getIconColor(props.backgroundVariant)};
    }
`;
